import { useEffect, useMemo } from 'react';
import PdfPreview from '@/app/components/cards/FileCard/PdfPreview';
import CrossImageIcon from '/public/icons/cross-image.svg';

interface SharePdfFileCardProps {
  file: File;
  onDelete: (file: File) => void;
}

export function SharePdfFileCard({ file, onDelete }: SharePdfFileCardProps) {
  const previewUrl = useMemo(() => URL.createObjectURL(file), [file]);

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  return (
    <div className="relative flex aspect-square w-full max-w-22.5 items-center justify-center p-1">
      <div className="relative flex items-center justify-center border border-blue-100 rounded-md overflow-hidden size-full">
        <PdfPreview fileUrl={previewUrl} containerWidth={82} containerHeight={82} />
      </div>
      <button
        type="button"
        className="absolute top-0 right-0 z-10 flex items-center justify-center w-[18px] h-[18px] rounded-full bg-red-500 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(file);
        }}
      >
        <CrossImageIcon className="w-[10px] h-[10px] text-white fill-current" />
      </button>
    </div>
  );
}
